import * as React from 'react';
import { SVGProps } from 'react';

const IconWellPipeSizeS = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M4 1h3v14H5V3H4V1Zm7 14V3h1V1H9v14h2Z"
    />
  </svg>
);
export default IconWellPipeSizeS;
